import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
const AddDiplomeMastere = props => {
  const [nameFr, setNameFr] = useState("")
  const [nameAr, setNameAr] = useState("")
  const [selectCycle, setSelectCycle] = useState("")
  const [cycele, setCycele] = useState([])
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    if(selectCycle === ""){
      toast.error("⛔ Cycle obligatoire", {
        containerId: "A",
      })
    }else if(nameAr === ""){
      toast.error("⛔ Nom AR obligatoire", {
        containerId: "A",
      })
    }else if(nameFr !== ""){
      API.post("master/diplome_master/add", {
        annee_id,
        nom_fr:nameFr,
        nom_ar:nameAr,
        cycle_master_id:selectCycle.value,
        user_id
      }).then(res => {
        toast.success(" 🔓✔️  Diplôme Mastére ajoutée Avec succès", {
          containerId: "A",
        })
        props.setSection(1)
      })

    } else {
      toast.error("⛔ Nom FR obligatoire", {
        containerId: "A",
      })
    }
  }
  useEffect(async () => {
    const res = await API.get("master/select_cycle").then(res => {
      setCycele(res.data.Cycles)
    })
  }, [])
  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            <Row >
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">Cycle :</Label>
                  <Select
                    options={cycele}
                    isSearchable={true}
                    onChange={e => setSelectCycle(e)}
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {"Diplôme Mastére Fr"}
                  </Label>
                  <Input
                    lg="3"
                    type="text"
                    className="form-control"
                    placeholder="Diplôme Mastére Fr"
                    required={true}
                    onChange={e => setNameFr(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                   {" Diplôme Mastére Ar"}
                  </Label>
                  <Input
                    lg="3"
                    type="text"
                    className="form-control"
                    placeholder="Diplôme Mastére Ar"
                    required={true}
                    onChange={e => setNameAr(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddDiplomeMastere)
AddDiplomeMastere.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
